__turbopack_context__.v({
  "inner": "smallButton-module__b7uJZq__inner",
  "label": "smallButton-module__b7uJZq__label",
  "loader": "smallButton-module__b7uJZq__loader",
  "root": "smallButton-module__b7uJZq__root",
  "section": "smallButton-module__b7uJZq__section",
});
